import React from 'react';

export default class Marquee extends React.Component<any, any> {
  static defaultProps = {
    text: '',
    speed: 0.5,
    delay: 500,
    style: {},
    verticalDir: false,
  };

  constructor(props) {
    super(props);
    this.containerWidth = 0;
    this.textWidth = 0;
    this.animating = false;
    this.mounted = false;
    this.containerHeight = 0;
    this.textHeight = 0;
    this.container = React.createRef();
    this.text = React.createRef();
  }

  componentDidMount() {
    this.mounted = true;
    const { delay } = this.props;
    setTimeout(() => {
      this.measureLayout();
    }, delay);
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps) {
    if (this.props.text !== nextProps.text) {
      this.measureLayout();
    }
  }

  componentDidUpdate() {
    this.measureLayout();
  }

  textHeight: number;
  containerWidth: number;
  textWidth: number;
  animating: boolean;
  mounted: boolean;
  containerHeight: number;
  container: any;
  text: any;

  measureLayout() {
    const containerElement = this.container.current;
    const textElement = this.text.current;
    const { verticalDir } = this.props;

    if (containerElement && textElement) {
      this.containerWidth = containerElement.offsetWidth;
      this.textWidth = textElement.offsetWidth;
      this.containerHeight = containerElement.offsetHeight;
      this.textHeight = textElement.offsetHeight;
      const shouldAnimate =
        this.containerWidth < this.textWidth ||
        (verticalDir && this.containerHeight < this.textHeight);

      if (shouldAnimate) {
        if (verticalDir) {
          !this.animating && this.startAnimationVertical(true);
        } else {
          !this.animating && this.startAnimation(true);
        }
      } else {
        this.stopAnimation();
      }
    }
  }

  startAnimationVertical = (initial = false) => {
    const { speed } = this.props;
    const textElement = this.text.current;

    const distance = this.textHeight + (initial ? 0 : this.containerHeight);
    const duration = distance / 100 / speed;

    if (textElement) {
      textElement.style.transition = `transform ${duration}s linear`;
      textElement.style.transform = `translate3D(0, -${this.textHeight}px, 0)`;
      this.animating = true;
    }
  };

  startAnimation = (initial = false) => {
    const { speed } = this.props;
    const textElement = this.text.current;

    const distance = this.textWidth + (initial ? 0 : this.containerWidth);
    const duration = distance / 100 / speed;

    if (textElement) {
      textElement.style.transition = `transform ${duration}s linear`;
      textElement.style.transform = `translate3D(-${this.textWidth}px, 0, 0)`;
      this.animating = true;
    }
  };

  stopAnimation = () => {
    const textElement = this.text.current;

    if (textElement) {
      textElement.style.transition = 'none';
      textElement.style.transform = 'none';
    }

    this.animating = false;
  };

  handleTransitionEnd = () => {
    const textElement = this.text.current;
    const { verticalDir } = this.props;

    const shouldAnimate =
      this.containerWidth < this.textWidth ||
      (verticalDir && this.containerHeight < this.textHeight);

    if (shouldAnimate) {
      if (textElement) {
        textElement.style.transition = 'none';

        if (verticalDir) {
          textElement.style.transform = `translate3D(0, ${this.containerHeight}px, 0)`;
          textElement.offsetHeight;

          this.startAnimationVertical();
        } else {
          textElement.style.transform = `translate3D(${this.containerWidth}px, 0, 0)`;
          textElement.offsetWidth;

          this.startAnimation();
        }
      }
    } else {
      this.stopAnimation();
    }
  };

  render() {
    const { className, text, style, verticalDir } = this.props;
    const textStyle = {
      display: 'inline-block',
      position: 'relative',
      whiteSpace: verticalDir ? 'pre-wrap' : 'nowrap',
    };

    return (
      <div
        ref={this.container}
        className={`xsdj-marquee ${className}`}
        style={{
          overflow: 'hidden',
          wordBreak: verticalDir ? 'break-all' : 'keep-all',
          ...style,
        }}
      >
        <span ref={this.text} style={textStyle as any} title={text} onTransitionEnd={this.handleTransitionEnd}>
          {text}
        </span>
      </div>
    );
  }
}
